<template>
  <div class="crudblock">
    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      :search.sync="form"
      @search-reset="searchReset"
      @on-load="onLoad"
      @search-change="searchChange"
    >
      <template slot="search" slot-scope="{ row, size }">
        <div class="block">
          <el-date-picker
            v-model="timepic"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </div>
        <div class="block">
          <el-input
            v-model="form.search"
            width="150px"
            placeholder="银行编号/银行名称/联系信息"
          ></el-input>
        </div>
      </template>
      <template slot="searchMenu" slot-scope="{ row, size }">
        <el-button type="primary" @click="save(row)">保存</el-button>
        <el-button  type="primary"  @click="screen"
          ><a-icon type="filter" /> 高级筛选</el-button
        >
      </template>
      <template slot="bankState" slot-scope="scope">
        <div class="bankstatediv">
          <div
            :class="['bankstatespan', 'bankstate_' + scope.row.bankState]"
          ></div>
          <div>{{ scope.row.$bankState }}</div>
        </div>
      </template>
      <template slot="contactName" slot-scope="scope">
        <div class="contactName">
          <div>{{ scope.row.contactName }}</div>
          <div>{{ scope.row.contactPhone }}</div>
        </div>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="success"
          plain
          size="small"
          icon="el-icon-arrow-right"
          @click.stop="handleDetails(scope.row.id)"
          >详情
        </el-button>
      </template>
    </avue-crud>
    <el-drawer
      title="高级筛选"
      :visible.sync="drawer"
      size="50%"
      custom-class="drawer_wrapper"
      :with-header="false"
    >
      <span>
        <div class="drawer_screen_wrapper">
          <div class="screen_header">
            <div class="screen_header_name">
              <a-icon type="filter" />
              高级筛选
            </div>
            <div class="screen_header_remarks" @click="drawer = false">
              <i class="el-icon-video-play"></i>
              收起
            </div>
          </div>
          <div class="screen_content">
            <avue-form
              :option="option"
              ref="formScreen"
              v-model="form"
              @submit="handleSearch"
              @reset-change="searchResetScreen"
            >
              <template slot="expireQuotaSlot">
                <div class="form_slot">
                  <el-input-number
                    v-model="form.expireQuotaMin"
                    :controls="false"
                    placeholder="开始数值"
                    style="width: 100%"
                  />
                  ~
                  <el-input-number
                    v-model="form.expireQuotaMax"
                    :controls="false"
                    placeholder="结束数值"
                    style="width: 100%"
                  />
                </div>
              </template>
              <template slot="quotaSlot">
                <div class="form_slot">
                  <el-input-number
                    v-model="form.quotaMin"
                    :controls="false"
                    placeholder="开始数值"
                    style="width: 100%"
                  />
                  ~
                  <el-input-number
                    v-model="form.quotaMax"
                    :controls="false"
                    placeholder="结束数值"
                    style="width: 100%"
                  />
                </div>
              </template>
            </avue-form>
          </div>
        </div>
      </span>
    </el-drawer>
    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="false"
      :clear="false"
      @setPeople="setPeople"
    />
  </div>
</template>

<script>
import * as api from "@/api/zd/bank";
import SelectPerson from "@/components/SelectPersonnel/person";
export default {
  data() {
    return {
      form: {},
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10
      },
      data: [],
      timepic: [],
      option: {
        menuType: "button",
        menuWidth: 120,
        addBtn: false,
        menuAlign: "center",
        card: true,
        delBtn: false,
        editBtn: false,
        align: "center",
        searchMenuSpan: 8,
        columnBtn: false,
        searchBtn: true,
        column: [
          {
            sortable: true,
            label: "银行编号",
            prop: "number",
            width: "120",
            fixed: true
          },
          {
            label: "银行名称",
            prop: "bankName",
            width: "180",
            fixed: true
          },
          {
            label: "合同状态",
            prop: "bankState",
            type: "select",
            slot: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=bank_state",

            props: {
              label: "dictValue",
              value: "dictKey"
            },
            dataType: "number"
          },

          {
            label: "合同期限",
            prop: "contractTerms",

            width: "160"
          },
          {
            label: "审核状态",
            prop: "auditState",
            type: "select",

            dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            dataType: "number"
          },
          {
            label: "联系信息",
            prop: "contactName",
            slot: true,
            width: "180"
          },

          {
            label: "客户经理",
            prop: "managerName",
            display: false,
          },
          {
            label: "客户经理",
            prop: "managerUserName",
            readonly: true,

            search: true,
            clearable: false,
            display: true,
            hide: true,
            hideshow: true,
            click: () => {
              this.selectPersonClick();
            },
          },
        ]
      },
      drawer:false
    };
  },
  watch: {
    files: {
      handler(newName, oldName) {
       
        if (oldName != undefined) {
          this.cloudTages(newName);
        }
      },

      immediate: true
    },
    timepic: {
      handler(newName, oldName) {
        if (oldName != undefined) {
          (this.form.startDate = this.timepic[0]),
            (this.form.endDate = this.timepic[1]);
        }
      },

      immediate: true
    }
  },
  props: ["files"],
  components: { 
  SelectPerson
},
  methods: {
    onLoad(page) {
      let data = [];
      if (
        this.form.startDate != "" ||
        this.form.search != "" ||
        this.form.managerName != ""
      ) {
        (data.startDate = this.form.startDate),
          (data.endDate = this.form.startDate);
        data.search = this.form.search;
        data.managerName = this.form.managerName;
        data.managerUserIds =  this.form.managerUserIds
      }
      api
        .bankmessagegetList({
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          auditState: 1,
          ...data
        })
        .then(res => {
         
          this.auditlistNub = res.data.data.shlb;
          this.page.total = res.data.data.total;
          this.data = res.data.data.list;
        })
        .catch(res => {
         
        });
    },
    searchChange(params, done) {
     
      // if (this.form.timepic) {
      //   this.form.startDate = this.form.timepic[0];
      //   this.form.endDate = this.form.timepic[1];
      //   delete this.form["timepic"];
      // }

      this.onLoad(this.page);
      done();
    },
    searchReset() {
      this.form = {};
      this.timepic = [];
      this.onLoad(this.page);
    },
    //高级筛选清空
     searchResetScreen(){
      this.$refs.crud.searchReset()
    },
    save(row) {
      this.$emit("rowdata", row);
    },
    cloudTages(data) {
      
      this.form = data;

      if (this.form.startDate) {
        this.timepic = [this.form.startDate, this.form.endDate];
      }
      this.searchChange(data);
    },
    handleDetails(id) {
    
      this.$router.push({ path: `/zd/bankmanage/bankmanageDetail/${id}` });

      // this.$router.push({
      //   path: "/zd/bankmanage/bankmanageDetail/",
      //   query: { id: id }
      // });
    },
    //显示高级筛选抽屉
    screen() {
      this.form = { ...this.form, ...this.query };
      this.drawer = true;
    },
    //高级筛选
    handleSearch(form, done, loading) {
      this.form = { ...this.form, ...form };
      this.drawer = false;
      this.page.currentPage = 1;
      this.onLoad(this.page);
      done();
    },
    //获取 人员名称
    getVisitPeople() {
      let people = this.checkUserList.map((item) => {
        return item.realName;
      });
      let ids = this.checkUserList.map((item) => {
        return item.id;
      });
      this.$nextTick(() => {
        this.form.managerUserName = people.join(",");
        this.form.managerUserIds = ids.join(",");
      });
    },
    // 人员选择插件打开
    selectPersonClick() {
      this.$refs.selectperson.showmode();
    },

    //人员 获取
    setPeople(val) {
      this.checkUserList = val;
      this.getVisitPeople();
    },
  }
};
</script>

<style lang="scss" scoped>
.crudblock {
  background: #ffff;
  padding:16px;
  border-radius: 4px;
}
</style>
